/* eslint-disable */

//Parent component for building filter, map (Mapbox), and map story well (MapStoryBuilder) 

import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Mapbox from '../graphics/Mapbox';
import MapStoryBuilder from '../helpers/mapstorybuilder'

import originalMapData from '../../assets/data/final_map_data.json';
import storyData from '../../assets/data/final_story_data.json';

import '~styles/modules/filtermap.scss';



let interests = ['art','bakery','bar','boston tours','brunch','dancing', 'dessert','dining','entertainment','food','history','kid-friendly','library','live music','museum','outdoor dining','park','poetry','seafood','shopping','sight-seeing','sports','trails','walking'];
let audiences = ['couples','families','locals','tourists'];

let audienceChoiceClass = "audience-filter-containers";
let audienceSelectedClass =  "audience-filter-selected";
let nonDefaultInterestClass = "non-default-selections";
let defaultInterestId = "all-selection";

let allSelection = "all";

const FilterMap = ({ data }) => {

  //States for map data and story data, with defaults.

  const [mapDataSource, updateData] = useState(originalMapData);
  const [mapStorySource, updateStoryData] = useState([]);

  //Helper function for creating array from data list

  function returnList(s){
    let result =  []
    let cleanS =  s.toLowerCase().split(',');
    for(let i = 0; i < cleanS.length; i++){
      result.push(cleanS[i].trim())
    }
    return result
  }

  React.useEffect(() => {

    //start with empty map
    updateData([]);

    if (typeof document !== `undefined`) { 

      //Housekeeping:

      //Grab form data
      let submitButton = document.getElementById("mapSubmit")
      let mapForm = document.forms["mapForm"]

      let audienceSelectionOptions = document.getElementsByClassName(audienceChoiceClass)
      let nonDefaultInterestSelectionOptions = document.getElementsByClassName(nonDefaultInterestClass)
      let allSelectionBox = document.getElementById(defaultInterestId);

      //Add toggle events to audience divs
      for(let i = 0; i < audienceSelectionOptions.length; i++){
        audienceSelectionOptions[i].addEventListener("click",function(){
          this.classList.toggle(audienceSelectedClass)
        });
      }

      //Listen for "all" selection. If "all" is selected, deselect other options and vice versa
      allSelectionBox.addEventListener('change', function(){
        if(this.checked){
          for(let i = 0; i < nonDefaultInterestSelectionOptions.length; i++){
              nonDefaultInterestSelectionOptions[i].checked = false;
           }
        }
      })

      for(let i = 0; i < nonDefaultInterestSelectionOptions.length; i++){
        nonDefaultInterestSelectionOptions[i].addEventListener('change', function(){
          if(nonDefaultInterestSelectionOptions[i].checked){
            allSelectionBox.checked = false;
          }
        })
      }

      //End Housekeeping


      //Form submission function:

      mapForm.addEventListener("submit", function(e){

        //Prevent auto page refresh
        e.preventDefault();

        let newMapData = [];
        let newStoryData =[];

        let checkboxSelections = document.getElementsByClassName('interest-selections');
        let audienceSelections = document.getElementsByClassName(audienceSelectedClass);
        let mapList = document.getElementById("map-list-container");

        let audienceSelectionArray = [];
        let interestsSelectionsArray = [];

        //Store user selections:

        for (let i = 0; i < checkboxSelections.length; i++){
          if(checkboxSelections[i].checked){
            interestsSelectionsArray.push(checkboxSelections[i].value.trim());
          }
        }

        for (let i = 0; i < audienceSelections.length; i++){
          let value = audienceSelections[i].getAttribute('data-value');
            audienceSelectionArray.push(value.toLowerCase().trim());
        
        }

        //If no checkbox selections, prompt for selectiosn
        if(interestsSelectionsArray.length==0){
          alert("Please select an interest.")
        }

        //If no audience selection has been made, make it default to all categories
        if(audienceSelectionArray.length==0){
          audienceSelectionArray = audiences;
        }

        //Filter the map list:

        //Loop over map data entries
        for(let i = 0; i < originalMapData.length; i++){

          //Store data entry's audience tags in an array, lowercase using helper function
          let audienceValues = returnList(originalMapData[i].Audience)

          //Store data entry's interest tags in an array, lowercase using helper function
          let interestValues = returnList(originalMapData[i].Category);

        //loop over user audience selection and check if any are inclulded in data entry's list
        loop1:
          for(let audi = 0; audi < audienceSelectionArray.length; audi++ ){

              let audiencePick= audienceSelectionArray[audi].trim();

              //If there is a match, move on
              if(audienceValues.includes(audiencePick)){

        loop2:
                //loop over user interest selection and check if any are inclulded in data entry's list
                for(let inte = 0; inte < interestsSelectionsArray.length; inte++){

                  let interestPick = interestsSelectionsArray[inte].trim();

                  //If user selection shows up in list of tags for this option OR
                  //If user selection is "all"
                  //Save data entry into new map data
                  if((interestValues.includes(interestPick))||(interestPick==allSelection)){
                    newMapData.push(originalMapData[i]);
                    break loop1;
                  }
                }
              }
          }
        }//end data loop


        //Filter the story recocmmendation list:

        //Loop over story data
        for(let i = 0; i < storyData.length; i++){

          //Store data entry's audience tags in an array, lowercase using helper function
          let audienceValues = returnList(storyData[i].Audience)

          //Store data entry's interest tags in an array, lowercase using helper function
          let interestValues = returnList(storyData[i].Category);
          

          //check if meets both audience and interest pick (or "all"). same as above
        loop1:
          for(let audi = 0; audi < audienceSelectionArray.length; audi++ ){
           
              let audiencePick= audienceSelectionArray[audi].trim();

              if(audienceValues.includes(audiencePick)){
              
        loop2:
                for(let inte = 0; inte < interestsSelectionsArray.length; inte++){

                  let interestPick = interestsSelectionsArray[inte].trim();
                  
                  if((interestValues.includes(interestPick))||(interestPick==allSelection)){
                    newStoryData.push(storyData[i]);
                    break loop1;

                  }
                }
              }

          }
        }//end data loop

        //Update FilterMap state with new data
        //This updates child components
        {updateData(newMapData)}
        {updateStoryData(newStoryData)}

      })
  
    }
  }, []);

  //Place content

  const audienceList = audiences.map((item) => {
    return (
      <div className={audienceChoiceClass} data-value={item}>
        {item}
      </div>
    );
  });

  const interestsList = interests.map((item) => {
    return (
      <div className="interest-items">
        <input className="interest-selections non-default-selections" type="checkbox" id={item+"-selection"} name={item+"-selection"} value={item} />
        <label for={item+"-selection"}> {item}</label>
      </div>
    );
  });

  return (
    <div>
    <form id="filter-container" name="mapForm">
      <div id="filter-content" className="content">
      
        <div className="filter-titles" id="audience-title">Audience</div>
        <div id="audience-list-container">
            {audienceList}
        </div>

        <div className="filter-titles" id="interest-title">Interests</div>
        <div id="interests-list-container">
          <div className="interests-list">
            <div className="interest-items">
              <input className="interest-selections default-selections" type="checkbox" id="all-selection" name="all-selection" value="all" />
              <label for={"all-selection"}> All</label>
            </div>
            {interestsList}
          </div>
        </div>

        <div id="filter-button-container">
          <input id="filter-submit-button" type="submit" value="SUBMIT"  id="mapSubmit"/>
          <div id="submit-triangle">&#x25BC;</div>
        </div>
      </div>
    </form>

    <div id="map-section">
      <Mapbox mapSource={mapDataSource} mapUpdatedValue="true" />
    </div>

   <hr className="dividers" />

   <MapStoryBuilder storyData={mapStorySource} />
   </div>
  
  );
};



export default FilterMap;
